// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pixel-manager-mf .page-view .v-input--radio-group__input{flex-wrap:nowrap}.pixel-manager-mf .page-view .v-input--radio-group__input .sr-input-box{margin-right:12px;min-width:250px;max-width:250px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
